export default "__VITE_ASSET__d050d392__"